import {Observable, of, from} from "rxjs";
import {mergeMap, map, toArray} from "rxjs/operators";
import {role} from "./stores";

export function getRef(ref) {
    return new Observable(subscriber => {
        ref.get().then((doc) => {
            if (doc.exists) {
                subscriber.next({...doc.data(), id: doc.id});
                subscriber.complete();
            } else {
                subscriber.error(new Error("Doc does not exists"));
            }
        });
    });
}

export function getMultiple(ref) {
    return new Observable(subscriber => {
        ref.get().then((qs) => {
            qs.forEach((doc) => {
                subscriber.next({...doc.data(), id: doc.id})
            });
            subscriber.complete();
        });
    });
}

/**
 * @param {int}params.id: Id of the sensor to fetch information
 * @param {string}params.client: Client ID
 * @returns {Observable<{thresholds: {warning: {display: string, value: number}, danger: {display: string, value: number}}, name: string, client: string, state: string, type: string, max_value: number}>}
 */
export function getSensorInformation(params) {
    return getRef(firebase.firestore().collection("sensors").doc(params.id));
}

/**
 * @param {int}id
 * @param {{}}sensor
 * @returns {*}
 */
export function updateSensorInformation(id, sensor = {}) {
    return firebase.firestore().doc("sensors/" + id).set(sensor, {merge: true});
}

export function createAlertWatch(watch = {}) {
    return firebase.firestore().collection("alert_watch").add({
        ...watch,
        user_ref: getUserRef()
    });
}

export function updateAlertWatch(id, watch = {}) {
    if (id === undefined) return createAlertWatch(watch);

    return firebase.firestore().doc("alert_watch/" + id).set(watch, {merge: true});
}

function getUserRef() {
    return firebase.firestore().collection("users").doc(firebase.auth().currentUser.uid)
}

export const DEFAULT_SENSOR_INFOS = {
    name: "Undefined",
    type: "Undefined",
    max_value: 100,
    thresholds: {danger: {}, warning: {}}
};

export function getSensors() {
    return getMultiple(firebase.firestore().collection("sensors"));
}

export function getWatchs() {
    return getMultiple(firebase.firestore().collection("alert_watch").where('user_ref', '==', getUserRef())).pipe(
        mergeMap(watch => getRef(watch.sensor_ref).pipe(
            map(sensor => ({...watch, sensor: sensor}))
        ))
    );
}

export function getWatch(id) {
    return getRef(firebase.firestore().collection("alert_watch").doc(id));
}

export function getAlerts(sort = true) {
    let observable = getMultiple(firebase.firestore().collection("alerts").where('user', '==', getUserRef()).where('viewed', '==', true));

    if (sort)
        return observable.pipe(
            toArray(),
            map(alertArray => alertArray.sort((a, b) => new Date(b.gqlsensor.last_message.date) - new Date(a.gqlsensor.last_message.date))),
            mergeMap(alertArray => from(alertArray))
        );
    else return observable;
}

export function getUnviewedAlerts(sort = true) {
    let observable = getMultiple(firebase.firestore().collection("alerts").where('user', '==', getUserRef()).where('viewed', '==', false));

    if (sort)
        return observable.pipe(
            toArray(),
            map(alertArray => alertArray.sort((a, b) => new Date(b.gqlsensor.last_message.date) - new Date(a.gqlsensor.last_message.date))),
            mergeMap(alertArray => from(alertArray))
        );
    else return observable;
}

export function getUsers() {
    return getMultiple(firebase.firestore().collection("users"));
}

export function getOrganizations() {
    return new Observable(subscriber => {
        firebase.functions().httpsCallable('getOrganizations')().then(data => {
            console.log(data.data.data.findOrganizations)
            for (const organization of data.data.data.findOrganizations) {
                subscriber.next(organization);
            }
            subscriber.complete();
        })
    })

    // var callable = firebase.functions().httpsCallable('getOrganizations')
    // callable().then(data => {
    //     console.log(data)
    // })
    //
    // return getMultiple(firebase.firestore().collection("clients"));
}

export function getRoles() {
    return getMultiple(firebase.firestore().collection("roles"));
}

export function updateUser(user = {}) {
    let newUser = {...user}
    delete newUser["id"]
    role.set(user.role.id);
    return firebase.firestore().doc("users/" + user.id).set(newUser, {merge: true});
}

export function getProductTypes() {
    return getMultiple(firebase.firestore().collection("productTypes"));
}

export function newProductType(name) {
    return firebase.firestore().collection("productTypes").add({
        name: name
    });
}